<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <ng-container *ngIf="openForm">
      <form [formGroup]="VendorFilterForm" class="filter-form">
        <ng-container>
          <emerald-dropdown
            [label]="'Performance Rating'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="performanceRating"
            [options]="performanceRatingOptions"
            [id]="'performance_rating_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

        </ng-container>
      </form>
    </ng-container>
    <ng-container actions>
      <div class="button-container">
        <span class="mdc-dialog__button">
          <emerald-button
            [label]="'Reset'"
            [type]="'Secondary'"
            (onClick)="reset()"
          ></emerald-button>
        </span>
        <span class="mdc-dialog__button">
          <emerald-button
            [label]="'Apply'"
            [type]="'Primary'"
            (onClick)="apply()"
          ></emerald-button>
        </span>
      </div>
    </ng-container>
  </div>
</div>
